/**
 * Track how many infinite scroll elements have actually been viewed.
 */

import { analytics } from "./analytics";

function extractAnalyticsData(ele) {
    const pageUrl = ele.dataset.pageTrackerUrl;
    let pageMeta = {};
    if ('pageTrackerAnalyticsPayload' in ele.dataset) {
        const analyticsPayload = JSON.parse(ele.dataset.pageTrackerAnalyticsPayload)
        pageMeta = analyticsPayload.page_meta;
    }
    return {
        page: pageUrl,
        page_meta: pageMeta,
    }
}

// fire the LoadedContentView event only after the content comes into view.
const intersectionObserver = new IntersectionObserver(
    (entries, observer) => {
        entries
            .filter((entry) => entry.isIntersecting)
            .forEach((entry) => {
                const el = entry.target;

                let payload = {
                    page: window.location.pathname,
                    loaded_content_number: el.dataset.analyticsInfScrollDoneCount
                };

                let tracker;
                if (el.matches('[data-page-tracker-url]')) {
                    tracker = el;
                } else {
                    tracker = el.querySelector('[data-page-tracker-url]');
                }

                if (tracker) {
                    payload = { ...payload, ...extractAnalyticsData(tracker) };
                }

                analytics.track('LoadedContentView', payload);

                // only fire the event once for this element
                observer.unobserve(el);
            });
    });


let doneCount = 1;
document.addEventListener('infScrollFetchComplete', (e) => {
    let $el = e.detail.content;
    // get native element from jQuery element
    let el = $el[0];
    el.dataset.analyticsInfScrollDoneCount = doneCount++;
    intersectionObserver.observe(el);
});
